"use strict";

var _slicedToArray = require("/opt/build/repo/app/node_modules/@babel/runtime/helpers/slicedToArray.js");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useResults = void 0;

var react_1 = __importDefault(require("react"));

var utility_1 = require("../utility");
/** This hook must never be used to render results */


var useResults = function useResults() {
  var _react_1$default$useS = react_1.default.useState([]),
      _react_1$default$useS2 = _slicedToArray(_react_1$default$useS, 2),
      results = _react_1$default$useS2[0],
      setResults = _react_1$default$useS2[1];

  var _react_1$default$useS3 = react_1.default.useState(),
      _react_1$default$useS4 = _slicedToArray(_react_1$default$useS3, 2),
      resultStats = _react_1$default$useS4[0],
      setResultStats = _react_1$default$useS4[1];

  var loading = react_1.default.useMemo(function () {
    return typeof (resultStats === null || resultStats === void 0 ? void 0 : resultStats.numberOfResults) === "undefined";
  }, [resultStats === null || resultStats === void 0 ? void 0 : resultStats.numberOfResults]);
  react_1.default.useEffect(function () {
    var handler = function handler(event) {
      setResults(event.detail);
    };

    window.addEventListener("@usereactify/search:results:update", handler);
    return function () {
      return window.removeEventListener("@usereactify/search:results:update", handler);
    };
  }, []);
  react_1.default.useEffect(function () {
    var handler = function handler(event) {
      setResultStats(event.detail);
    };

    window.addEventListener("@usereactify/search:resultStats:update", handler);
    return function () {
      return window.removeEventListener("@usereactify/search:resultStats:update", handler);
    };
  }, []);

  var handleSetResults = function handleSetResults(value) {
    var event = new CustomEvent("@usereactify/search:results:update", {
      detail: value
    });
    window.dispatchEvent(event);
  };

  var handleSetResultStats = function handleSetResultStats(value) {
    var event = new CustomEvent("@usereactify/search:resultStats:update", {
      detail: value
    });
    window.dispatchEvent(event);
  };

  utility_1.debug.hook("useResults", "results", results);
  utility_1.debug.hook("useResults", "resultStats", resultStats);
  return {
    loading: loading,
    results: results,
    setResults: handleSetResults,
    resultStats: resultStats,
    setResultStats: handleSetResultStats
  };
};

exports.useResults = useResults;